export const PVP_GUIDE_ROOM_PENDING_KEY = 'pvp-room-pending'
export const PVP_GUIDE_PRIZE_PENDING_KEY = 'pvp-prize-pending'
export const GACHA_GUIDE_PRIZE_PENDING_KEY = 'gacha-prize-pending'
